import { appendIf } from '@btime/helpers'
import { assoc, compose, pick, prop } from 'ramda'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertDynamicServiceOrder($input: DynamicServiceOrderInput) {
    upsertDynamicServiceOrder(input: $input) {
      id
    }
  }
`
const cleanRequest = form => {
  return compose(
    pick([
      'checklistId',
      'placeId',
      'name',
      'description',
      'id',
      'themeColor',
      'logoId',
      'redirectToExecution',
      'configuration'
    ]),
    assoc('checklistId', form.checklist?.id || null),
    assoc('placeId', form.place?.id ? Number(form.place.id) : null),
    assoc('logoId', form.logo?.id || null),
    assoc('themeColor', form.themeColor || null),
    assoc('redirectToExecution', !!form.redirectToExecution),
    assoc(
      'configuration',
      compose(
        JSON.stringify,
        pick(['titleMessage', 'bodyMessage', 'placeLevels', 'placeTypes']),
        item => assoc('titleMessage', prop('titleMessage', item), item),
        item => assoc('bodyMessage', prop('bodyMessage', item), item),
        item => assoc('placeLevels', prop('placeLevels', item), item),
        item => assoc('placeTypes', prop('placeTypes', item), item)
      )(form?.configuration)
    )
  )(form)
}

const validate = (form, setErrors, t) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: t('validations:required') }),
    ...appendIf(!form.description, { path: ['description'], message: t('validations:required') }),
    ...appendIf(!form.checklist?.id, { path: ['checklist'], message: t('validations:required') })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveDynamicServiceOrders = () => {
  const { t } = useTranslation('validations')
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['DynamicServiceOrders'],
    client: serviceOrdersClient
  })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)

    const { setErrors } = actions
    const isValid = validate(form, setErrors, t)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
